module.exports = __webpack_public_path__ + "img/ads_nophoto.7b045d27.png";